import { render, staticRenderFns } from "./ConfirmDeletionSyllabuses.vue?vue&type=template&id=6ccba718&"
import script from "./ConfirmDeletionSyllabuses.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletionSyllabuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports